import { Document } from '../../types/Document';
import { api } from './api';

export default class DocumentDownloadService {
    async downloadDocument(token: string, doc: Document, fileName: string) {
        let url = `/document/${doc.partner}/${doc.aggregateType}/${doc.referenceId}/${doc.documentId}`;
        const resp = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        Promise.resolve(resp.blob())
            .then((blob) => {
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.download = fileName.replaceAll(' ', '_');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
            .catch((err) => console.error(err));
    }

    async uploadKYCDocument(file: File, leadId: string, token: string) {
        if (this.isPdfFile(file)) {
            const data = new FormData();
            data.append('file', file, file.name);
            return await fetch(`${api.kycDocument}/${leadId}`, {
                method: 'POST',
                body: data,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        }
    }

    async deleteKYCSheet(leadId: string, token: string) {
        return await fetch(`${api.kycDocument}/${leadId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }

    private isPdfFile(file: File): Boolean {
        return file.name.endsWith('pdf') && file.type === 'application/pdf' && file.size > 0;
    }
}
